import { useMemo, useState } from 'react';

export interface StateObj<T> {
  readonly value: T;
  set: (value: T) => void;
}

export function useStateObj<T = undefined>(initialValue?: T): StateObj<T> {
  const [value, setValue] = useState<T>(initialValue as T);

  return useMemo(
    () => ({
      get value() {
        return value;
      },
      set: setValue,
    }),
    [value, setValue],
  );
}
